import { render, staticRenderFns } from "./TalentHome.vue?vue&type=template&id=384ee96f&"
import script from "./TalentHome.vue?vue&type=script&lang=js&"
export * from "./TalentHome.vue?vue&type=script&lang=js&"
import style0 from "./TalentHome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports